// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8203f698","239":"0daf398c","455":"690c089c"}[chunkId] + ".chunk.js";
};